import { DashboardInfo } from "./DashboardInfo";
import { useContext, useState, useEffect } from "react";
import { UserContext } from "../../context/user.context";
import { CallCenterAPI } from "../../utils/callcenterAPI";

import { UilBill, UilShoppingCart, UilSync } from "@iconscout/react-unicons";
import { Link } from "react-router-dom";

import ScaleLoader from "react-spinners/ScaleLoader";
import {
  fetchOrdersHistory,
  fetchBalance,
  fetchPaymentsHistory,
  fetchLastOrder,
} from "../../utils/SonicAPIV2";

export const Dashboard = () => {
  const { currentUser, setCustomerDetails } = useContext(UserContext);

  const env_var = process.env.NODE_ENV;

  // set Icash Balance
  const [iCashBalance, setICashBalance] = useState(0);

  //get and set Payment Amount and Last 5 Invoices
  const [lastPaymentAmount, setLastPaymentAmount] = useState(0);
  const [lastPayments, setLastPayments] = useState({});
  const [paymentsCount, setPaymentsCount] = useState(0);
  const [paymentLoading, setPaymentLoading] = useState(false);

  //get and set Order Amount and Last 5 Orders
  const [lastOrders, setLastOrders] = useState([]);
  const [lastOrderNetTotal, setLastOrderNetTotal] = useState(0);
  const [ordersCount, setOrdersCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [messageCenter, setMessageCenter] = useState("");

  useEffect(() => {
    // console.log("currentUser in Dashboard:", currentUser);
    RefreshData();
  }, []);

  async function RefreshData() {
    setLoading(true);
    //console.log(params);

    try {
      const [customerDetails, customerICash, customerOrders, customerPayments] =
        await Promise.all([
          // getCustomerDetails(params),
          getCustomerICash(),
          //getCustomerOrdersHistory({ summary: true, limit: 5 }),
          getCustomerOrdersHistory({ summary: true, limit: 5 }),
          getCustomerPaymentsHistory({ summary: true, limit: 5 }),
        ]);

      // You can use the responses here if needed
      console.log("Details:", customerDetails);
      // console.log("iCash:", customerICash);
      // console.log("Orders:", customerOrders);
      // console.log("Payments:", customerPayments);
    } catch (error) {
      console.error("Error while refreshing data:", error);
    } finally {
      setLoading(false);
    }
  }

  const getCustomerDetails = async (params) => {
    //console.log(params);
    if (Object.keys(params).length !== 0) {
      const CustomerDetails = await CallCenterAPI().getCustomerDetails(params);
      // console.log("Customer Details");
      // console.log(CustomerDetails);
      // console.log("***************");

      if (!CustomerDetails) {
        console.log("No customer details found");
        return;
      }

      // console.log(
      //   `CustomerDetails.data.numbers[0].number : ${CustomerDetails.numbers}`
      // );
      setCustomerDetails({
        name: CustomerDetails?.data?.name || "",
        email: CustomerDetails?.data?.email || "",
        source: "web",
        DOB: "1990-01-01",
        AreaId: CustomerDetails?.data?.areaId || null,
        landmark: CustomerDetails?.data?.landmark || "",
        bldgName: CustomerDetails?.data?.bldgName || "",
        countryID: CustomerDetails?.data?.countryID || null,
        stateID: CustomerDetails?.data?.stateID || null,
        cityID: CustomerDetails?.data?.cityID || null,
        flatNumber: CustomerDetails?.data?.flatNumber || "",
        postcode: "000000",
        Currency: "AED",
        splGroupCode: CustomerDetails?.data?.splGroupCode || "",
        addresses:
          CustomerDetails?.data?.addresses?.length > 0
            ? [
                {
                  address: CustomerDetails.data.addresses[0].address || "",
                  is_Default: true,
                },
              ]
            : [],
        numbers:
          CustomerDetails?.data?.numbers?.length > 0
            ? [
                {
                  number: CustomerDetails.data.numbers[0].number || "",
                  is_Default: true,
                  CountryId: 1,
                },
              ]
            : [],
      });
    }
  };

  const getCustomerICash = async () => {
    try {
      const customerICash = await fetchBalance();
      // console.log("ICash Balance fetched:");
      // console.log(customerICash.balance);
      // console.log("***********************");

      if (!customerICash || !customerICash.balance) {
        console.log("No iCash balance found");
        setICashBalance(0);
        return;
      }

      setICashBalance(customerICash.balance);

      // Safe check for both response and nested `data` and `balance`
    } catch (error) {
      console.error("Error fetching iCash balance:", error);
      setICashBalance(0);
    }
  };

  // const getCustomerPaymentsHistory = async ({ summary, limit }) => {
  //   let mounted = true;
  //   async function load() {
  //     setLoading(true);
  //     setError(null);
  //     console.log(
  //       `Fetching payments history with summary=${summary}, limit=${limit}`
  //     );
  //     try {
  //       const data = await fetchPaymentsHistory(summary, limit);

  //       console.log(`Payments history data: ${JSON.stringify(data)}`);

  //       if (!mounted) return;
  //       setLastPayments(data.lastPayments || []);
  //       setLastPaymentAmount(Number(data.lastPaymentAmount || 0));
  //       setPaymentsCount(Number(data.paymentsCount || 0));
  //     } catch (err) {
  //       if (!mounted) return;
  //       setError(err.message || "Failed to load payments");
  //     } finally {
  //       if (mounted) setLoading(false);
  //     }
  //   }
  //   load();
  //   return () => {
  //     mounted = false;
  //   };
  // };

  const getCustomerPaymentsHistory = async ({
    summary = true,
    limit = 5,
  } = {}) => {
    let mounted = true;

    async function load() {
      setLoading(true);
      setError(null);
      // console.log(
      //   `Fetching payments history with summary=${summary}, limit=${limit}`
      // );
      try {
        const data = await fetchPaymentsHistory({ summary, limit });

        // console.log(`Payments history data: ${JSON.stringify(data)}`);

        if (!mounted) return;
        setLastPayments(data.lastPayments || []); // Limit of last payments
        setLastPaymentAmount(Number(data.lastPaymentAmount || 0)); // Latest payment amount
        setPaymentsCount(Number(data.paymentsCount || 0)); // Total payments count
      } catch (err) {
        if (!mounted) return;
        setError(err.message || "Failed to load payments");
      } finally {
        if (mounted) setLoading(false);
      }
    }

    load();
    return () => {
      mounted = false;
    };
  };

  // const getCustomerOrdersHistory = async (summary, limit) => {
  //   let mounted = true;
  //   async function load() {
  //     setLoading(true);
  //     setError(null);
  //     try {
  //       const data = await fetchOrdersHistory(summary, limit);

  //       // console.log(`Orders history data: ${JSON.stringify(data)}`);

  //       if (!mounted) return;
  //       setLastOrders(data.lastOrders || []);
  //       setLastOrderNetTotal(Number(data.lastOrderNetTotal || 0));
  //       setOrdersCount(Number(data.ordersCount || 0));
  //     } catch (err) {
  //       if (!mounted) return;
  //       setError(err.message || "Failed to load orders");
  //     } finally {
  //       if (mounted) setLoading(false);
  //     }
  //   }
  //   load();
  //   return () => {
  //     mounted = false;
  //   };
  // };

  // const getLastOrder = async () => {
  //   try {
  //     const lastOrder = await fetchLastOrder();
  //     console.log("Last Order fetched:");
  //     console.log(lastOrder);
  //     console.log("***********************");
  //     if (!lastOrder || lastOrder.success === false) {
  //       console.log("No last order found");
  //       setLastOrders([]);
  //       setLastOrderNetTotal(0);
  //       setOrdersCount(0);
  //       return;
  //     }
  //     setLastOrders([lastOrder.data || []]);
  //   } catch (error) {
  //     console.error("Error fetching last order:", error);
  //   }
  // };

  const getCustomerOrdersHistory = async ({
    summary = true,
    limit = 5,
  } = {}) => {
    let mounted = true;

    async function load() {
      setLoading(true);
      setError(null);

      try {
        const data = await fetchOrdersHistory({ summary, limit });

        if (!mounted) return;

        setLastOrders(data.lastOrders || []); // 5 most recent orders
        setLastOrderNetTotal(Number(data.lastOrderNetTotal || 0)); // Latest order's net total
        setOrdersCount(Number(data.ordersCount || 0)); // Total orders count
      } catch (err) {
        if (!mounted) return;
        setError(err.message || "Failed to load orders");
      } finally {
        if (mounted) setLoading(false);
      }
    }

    load();
    return () => {
      mounted = false;
    };
  };

  function PaymentList({ lastPayments }) {
    if (!lastPayments || lastPayments.length === 0) return null;

    //console.log(payments);
    if (lastPayments.length !== 0) {
      return (
        <div>
          <ul
            role="list"
            className="divide-y divide-gray-200 dark:divide-gray-700"
          >
            {lastPayments &&
              lastPayments.map((item, index) => (
                <li className="py-3 sm:py-4" key={index}>
                  <div className="flex items-center space-x-4">
                    <div className="flex-shrink-0">
                      <UilBill className="w-8 h-8 text-primaryHover " />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-gray-900 truncate dark:text-white">
                        {item.invoiceNumber}
                      </p>
                      <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                        {item.paymentType}
                      </p>
                    </div>
                    <div className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                      {parseFloat(item.paidAmt).toFixed(2)} <br />
                      AED
                    </div>
                  </div>
                </li>
              ))}
          </ul>
        </div>
      );
    }
  }

  function OrdersList({ lastOrders }) {
    //console.log(`lastOrders: ${JSON.stringify(lastOrders)}`);
    if (!lastOrders || lastOrders.length === 0) return null;

    return (
      <div>
        <ul
          role="list"
          className="divide-y divide-gray-200 dark:divide-gray-700"
        >
          {lastOrders.map((item, index) => (
            <li className="py-3 sm:py-4" key={index}>
              <div className="flex items-center space-x-4">
                <div className="flex-shrink-0">
                  <UilShoppingCart className="w-8 h-8 text-primaryHover" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate dark:text-white">
                    {item.orderNumber}
                  </p>
                  <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                    Items Count: {item.orderItems?.length || 0}
                  </p>
                </div>
                <div className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                  {parseFloat(item.netTotal).toFixed(2)} <br />
                  AED
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div>
      <div className="flex mx-auto max-w-screen-lg justify-start items-start mb-48">
        <div className="ml-2 mr-2 mt-4 gap-y-5 w-10/12 h-fit px-6 max-w-full rounded-md font-poppins justify-start items-start">
          {/* */}
          <div>
            <ScaleLoader
              color="#36d7b7"
              height={40}
              loading={loading}
              radius={2}
              width={4}
            />
          </div>
          <div>
            <div className="flex flex-row gap-5 items-center">
              <div className="text-navarbarText text-3xl font-poppins font-medium mb-8">
                User Dashboard
                <p className="text-base text-darkTextColor font-poppins font-normal">
                  Please click on refresh button if data not sync
                </p>
              </div>

              <button
                className="flex rounded-md bg-secondary h-10 w-10 items-center justify-center text-center"
                onClick={RefreshData}
              >
                <UilSync className="w-6 text-textWhite" />
              </button>
            </div>
            <DashboardInfo
              iCashBalance={iCashBalance}
              lastInvoiceAmount={lastPaymentAmount}
              lastOrderAmount={lastOrderNetTotal}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 mt-10 gap-4">
            {/* Last 5-6 payments */}
            <div className="w-full max-w-md p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700">
              <div className="flex items-center justify-between mb-4">
                <h5 className="text-xl font-bold leading-none text-gray-900 dark:text-white">
                  Last 5 Payments
                </h5>
                <Link
                  to="../payments"
                  state={{ PageTitle: "Payment(s) History" }}
                  className="text-navarbarText hover:text-primaryHover flex flex-row gap-2 text-base font-poppins font-medium"
                >
                  View All ({paymentsCount})
                </Link>
              </div>

              <div>
                {lastPayments.length > 0 ? (
                  <PaymentList lastPayments={lastPayments} />
                ) : (
                  <p>No Record found</p>
                )}
              </div>
            </div>

            {/* Last 5-6 Orders */}
            <div className="w-full max-w-md p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700">
              <div className="flex items-center justify-between mb-4">
                <h5 className="text-xl font-bold leading-none text-gray-900 dark:text-white">
                  Last 5 Orders
                </h5>
                <Link
                  to="../orders"
                  state={{ PageTitle: "Order(s) History" }}
                  className="text-navarbarText hover:text-primaryHover flex flex-row gap-2 text-base font-poppins font-medium"
                >
                  View All ({ordersCount})
                </Link>
              </div>
              <div>
                <div>
                  {lastOrders.length > 0 ? (
                    <OrdersList lastOrders={lastOrders} />
                  ) : (
                    <p>No Record found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
